"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var histogram_1 = require("../render/histogram");

var render_utils_1 = require("../render/render_utils");

var table_1 = require("../render/table");

var dom_1 = require("../util/dom");

var math_1 = require("../util/math");

function modelSummary(container, model) {
  return __awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var drawArea, summary, headers, values;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            drawArea = render_utils_1.getDrawArea(container);
            summary = getModelSummary(model);
            headers = ['Layer Name', 'Output Shape', '# Of Params', 'Trainable'];
            values = summary.layers.map(function (l) {
              return [l.name, l.outputShape, l.parameters, l.trainable];
            });
            table_1.table(drawArea, {
              headers: headers,
              values: values
            });

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}

exports.modelSummary = modelSummary;

function layer(container, layer) {
  return __awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3() {
    var _this = this;

    var drawArea, details, headers, weightsInfoSurface, detailValues, histogramSelectorSurface, layerValuesHistogram, handleSelection;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            drawArea = render_utils_1.getDrawArea(container);
            _context3.next = 3;
            return getLayerDetails(layer);

          case 3:
            details = _context3.sent;
            headers = ['Weight Name', 'Shape', 'Min', 'Max', '# Params', '# Zeros', '# NaNs', '# Infinity'];
            weightsInfoSurface = dom_1.subSurface(drawArea, 'layer-weights-info');
            detailValues = details.map(function (l) {
              return [l.name, l.shape, l.stats.min, l.stats.max, l.weight.size, l.stats.numZeros, l.stats.numNans, l.stats.numInfs];
            });
            table_1.table(weightsInfoSurface, {
              headers: headers,
              values: detailValues
            });
            histogramSelectorSurface = dom_1.subSurface(drawArea, 'select-layer');
            layerValuesHistogram = dom_1.subSurface(drawArea, 'param-distribution');

            handleSelection = function handleSelection(layerName) {
              return __awaiter(_this, void 0, void 0,
              /*#__PURE__*/
              _regeneratorRuntime.mark(function _callee2() {
                var layer, weights;
                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        layer = details.filter(function (d) {
                          return d.name === layerName;
                        })[0];
                        _context2.next = 3;
                        return layer.weight.data();

                      case 3:
                        weights = _context2.sent;
                        histogram_1.histogram(layerValuesHistogram, weights, {
                          height: 150,
                          width: 460,
                          stats: false
                        });

                      case 5:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2);
              }));
            };

            addHistogramSelector(details.map(function (d) {
              return d.name;
            }), histogramSelectorSurface, handleSelection);

          case 12:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
}

exports.layer = layer;

function getModelSummary(model) {
  return {
    layers: model.layers.map(getLayerSummary)
  };
}

function getLayerSummary(layer) {
  var outputShape;

  if (Array.isArray(layer.outputShape[0])) {
    var shapes = layer.outputShape.map(function (s) {
      return formatShape(s);
    });
    outputShape = "[".concat(shapes.join(', '), "]");
  } else {
    outputShape = formatShape(layer.outputShape);
  }

  return {
    name: layer.name,
    trainable: layer.trainable,
    parameters: layer.countParams(),
    outputShape: outputShape
  };
}

function getLayerDetails(layer) {
  return __awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee4() {
    var weights, layerVariables, statsPromises, stats, shapes;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            weights = layer.getWeights();
            layerVariables = layer.weights;
            statsPromises = weights.map(math_1.tensorStats);
            _context4.next = 5;
            return Promise.all(statsPromises);

          case 5:
            stats = _context4.sent;
            shapes = weights.map(function (w) {
              return w.shape;
            });
            return _context4.abrupt("return", weights.map(function (weight, i) {
              return {
                name: layerVariables[i].name,
                stats: stats[i],
                shape: formatShape(shapes[i]),
                weight: weight
              };
            }));

          case 8:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
}

function formatShape(shape) {
  var oShape = shape.slice();

  if (oShape.length === 0) {
    return 'Scalar';
  }

  if (oShape[0] === null) {
    oShape[0] = 'batch';
  }

  return "[".concat(oShape.join(','), "]");
}

function addHistogramSelector(items, parent, selectionHandler) {
  var select = "\n    <select>\n      ".concat(items.map(function (i) {
    return "<option value=".concat(i, ">").concat(i, "</option>");
  }), "\n    </select>\n  ");
  var button = "<button>Show Values Distribution for:</button>";
  var content = "<div>".concat(button).concat(select, "</div>");
  parent.innerHTML = content;
  var buttonEl = parent.querySelector('button');
  var selectEl = parent.querySelector('select');
  buttonEl.addEventListener('click', function () {
    selectionHandler(selectEl.selectedOptions[0].label);
  });
}